/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE:  you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import * as tslib_1 from "tslib";
import { GridCellBase } from "./GridCellBase";
import { markType } from "igniteui-react-core";
/**
 * @hidden
 */
var VerticalSeparatorCell = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(VerticalSeparatorCell, _super);
    function VerticalSeparatorCell(a) {
        var _this = _super.call(this, a) || this;
        _this.z.setStyleProperty("background-clip", "padding-box");
        return _this;
    }
    VerticalSeparatorCell.prototype.bq = function (a, b, c, d, e) {
        if (a == null) {
            this.z.setRawStyleProperty("border", "");
        }
        else {
            this.z.setRawStyleProperty("border-color", a._fill);
            this.z.setRawStyleProperty("border-left-width", b == 1 ? "thin" : b.toString() + "px");
            this.z.setRawStyleProperty("border-top-width", c.toString() + "px");
            this.z.setRawStyleProperty("border-right-width", d == 1 ? "thin" : d.toString() + "px");
            this.z.setRawStyleProperty("border-bottom-width", e.toString() + "px");
            this.z.setRawStyleProperty("border-style", "solid");
        }
    };
    VerticalSeparatorCell.$t = markType(VerticalSeparatorCell, 'VerticalSeparatorCell', GridCellBase.$);
    return VerticalSeparatorCell;
}(GridCellBase));
export { VerticalSeparatorCell };
//# sourceMappingURL=VerticalSeparatorCell.js.map
